export const isScrollEnabled = () =>
  document.getElementById("stepper-and-summary") === null;
